export const saveGoBackPage = (page) => {
  console.log("DEBUG: saving go-back page", page);
  localStorage.setItem("go-back-page", page);
};

export const removeLastSavedPage = () => {
  console.log("DEBUG: removing go-back page");
  localStorage.removeItem("go-back-page");
};
